export const itemListProps = {
    key: 0,
    item_id: null,
    item_detail: {id: 0, profile_photo: '', sku_code: '', article_name: '', unit_name: ''},
    link: '',
    title: '',
    image_path: ''
}

export const featureItemProps = {
    key: 0,
    title: '',
    link: '',
    item_list: []
}

export let dataProps = {
    id: 0,
    home_page_banner_type: 0,//dual pane, slider, single banner
	
    dual_pane_items: [JSON.parse(JSON.stringify(itemListProps)), JSON.parse(JSON.stringify(itemListProps))],
    slider_items: [JSON.parse(JSON.stringify(itemListProps))],
    single_banner_item: JSON.parse(JSON.stringify(itemListProps)),

    show_feature_list: false,
    feature_list_items: [JSON.parse(JSON.stringify(featureItemProps))],
    applicable_stores: []
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreHomePage/properties.js